import { useMemo } from "react";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import CategoryGrid from "./components/CategoryGrid";
import FeatureCards from "./components/FeatureCards";
import CTASection from "./components/CTASection";
import TestimonialSection from "./components/TestimonialSection";
import BlogSection from "./components/BlogSection";
import Footer from "@/components/feature/Footer";

export default function Home() {
  const webPageSchema = useMemo(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || "https://sugargoospreadsheet.asia";
    return {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Sugargoo Spreadsheet Guide - Find the Best Spreadsheet for Sugargoo Shopping",
      "description": "Discover the ultimate Sugargoo Spreadsheet guide for 2026. Compare curated spreadsheets for shoes, hoodies, t-shirts, jackets, and accessories. Find the best Sugargoo shopping spreadsheet to save time and money on your agent orders.",
      "url": siteUrl,
      "mainEntity": {
        "@type": "Organization",
        "name": "SugarGoo Spreadsheet",
        "url": siteUrl,
      },
    };
  }, []);

  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <HeroSection />
      <AboutSection />
      <CategoryGrid />
      <FeatureCards />
      <CTASection />
      <TestimonialSection />
      <BlogSection />
      <Footer />
    </main>
  );
}